export type Auth = {
    token: string;
    organizationId: string;
};
